import { APP_INITIALIZER } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SvgIconRegistryService } from 'src/app/common/icon/icon-registry.service';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';

const initRegistry = (iconRegistryService: SvgIconRegistryService, platformId: any) => () =>
  forkJoin(
    [
      'arrows-clockwise',
      'arrow-left',
      'bed',
      'bell',
      'beer-bottle',
      'bookmark-simple',
      'bookmark-fill',
      'calendar',
      'calendar-blank',
      'car',
      'caret-down',
      'caret-left',
      'caret-right',
      'chart-bar',
      'chat-circle-text',
      'chat-text',
      'clock',
      'compass',
      'CUSTOM-backpack',
      'CUSTOM-bello',
      'CUSTOM-bello-stroked',
      'CUSTOM-bookmark-simple-stroked',
      'CUSTOM-car-bike',
      'CUSTOM-cookie',
      'CUSTOM-event',
      'CUSTOM-quantita',
      'CUSTOM-stripe-outline',
      'CUSTOM-su-misura',
      'CUSTOM-user-circle',
      'CUSTOM-worker',
      'CUSTOM-cherrymeter',
      'CUSTOM-wheel',
      'CUSTOM-i-miei-acquisti',
      'dots-three-vertical',
      'envelope-open',
      'eye',
      'eye-slash',
      'event',
      'facebook-logo',
      'gear',
      'globe',
      'gift',
      'handbag',
      'house',
      'info',
      'instagram-logo',
      'linkedin-logo',
      'list',
      'lock-key',
      'lock-simple',
      'lock-simple-open',
      'magnifying-glass',
      'map-trifold',
      'note',
      'pencil',
      'pencil-line',
      'pencil-simple',
      'person-simple-walk',
      'plus-circle',
      'scales',
      'share-network',
      'sign-in',
      'sign-out',
      'sliders',
      'star',
      'swatches',
      'CUSTOM-trips',
      'user',
      'user-circle',
      'user-circle-gear',
      'user-plus',
      'users',
      'users-three',
      'x',
      'youtube-logo',
      'wifi-slash',
      'CUSTOM-preferiti',
      'preferiti-mobile',
      'zaino',
      'carrello',
      'zaino-desktop',
      'ico-community',
      'ico-community-sfumata',
      'farm',
      'grains',
      'map-pin-area',
      'windmill',
      'compass-tool',
    ]
      .map(svg => {
        let type = 'phosphor';
        if (svg.startsWith('CUSTOM-', 0)) {
          type = 'custom';
          svg = svg.replace('CUSTOM-', '');
        }
        const name = svg;
        let url = `/assets/icons/${type}/${name}.svg`;
        if (isPlatformServer(platformId)) {
          url = environment.baseUrl + url;
        }
        return { url: url, name: svg };
      })
      .map(svg => iconRegistryService.loadSvg(svg.url, svg.name)),
  );
export const INIT_ICON_REGISTRY = {
  provide: APP_INITIALIZER,
  useFactory: initRegistry,
  multi: true,
  deps: [SvgIconRegistryService, PLATFORM_ID],
};
